const fr = {
    text: {
        search: "Rechercher",

        login_title: "Connexion",
        loginaccount_title: "Connexion",
        login_btn_login: "Se connecter avec Email ou Téléphone",
        login_tip: "Lire et accepter",
        login_tip_privacy_policy: "Politique de confidentialité",
        login_tip_and: "et",
        login_tip_service_rules: "Conditions d’utilisation",
        login_not_have_account: "Pas de compte ?",
        login_btn_register: "S’inscrire",
        login_msg: "Veuillez accepter la Politique de Confidentialité et les Conditions d’Utilisation de Senda.",
        registered_cna: "Créer un nouveau compte",
        registered_phn: "Numéro de téléphone",
        registered_cfn: "Confirmer le numéro",
        registered_etc: "Saisissez le code envoyé à",
        registered_snc: "Envoyer un nouveau code",
        registered_vfc: "Code de vérification",
        registered_spa: "Définir le mot de passe",
        registered_cht: "caractères",
        registered_gtl: "Aller à la connexion",
        registered_ath: "Aller à l’accueil",

        registered_wrtyt: "Inscription réussie", // 注册成功
        registered_wokjt: "Redirection automatique vers la page de connexion", // 自动进入登录页
        login_fail: "Échec de connexion", // 登陆失败
        login_fail_tip: "Compte ou mot de passe incorrect. Veuillez réessayer.", // 账号或密码错误，请重新输入
        verification_code_error: "Code de vérification incorrect", // 验证码错误
        successful_gtt: "Réinitialisation du mot de passe réussie", // 重置密码成功
        perfect_qwer: "Sélectionner l’indicatif du pays", // 选择国家区号
        perfect_tyui: "Choisir un pays", // 选择国家
        perfect_qsde: "Choisir une région", // 选择地区
        information_mne: "Choisir un genre", // 选择性别
        perfect_oill: "Informations complètes", // 信息已完善
        perfect_nnmj: "secondes avant d’entrer automatiquement dans la page de prise de rendez-vous", // 自动进入门店预约
        perfect_ndyy: "Passer la réservation en magasin", // 跳转门店预约
        able_iju: "Aucun résultat pour ce filtre, essayez d’en changer", // 当前筛选项无匹配结果
        able_wer: "Aucune donnée disponible pour le moment", // 暂无相关数据
        vori_sdw: "Favori supprimé avec succès", // 取消收藏成功
        entif_oiu: "Identification en cours", // 正在识别
        scan_for_qr_code: "Scanner le code QR", // 扫描二维码
        scan: "Scan", // 扫描
        switch_camera: "Changer de caméra", // 切换摄像头
        up_suu: "Déconnexion", // 登出
        up_swu: "Confirmer la déconnexion ?", // 确认登出？
        up_slu: "Compte déconnecté", // 账号已登出
        seguridad_kja: "Confirmer la dissociation ?", // 确认解绑？
        seguridad_siu: "Après la dissociation,", // 解绑XX后
        seguridad_siu2: "ce mode de connexion ne pourra plus être utilisé pour ce compte", // 将无法继续使用它登录该账号
        browse_xccfv: "Remplir l’évaluation du service", // 服务评价填写
        browse_erty: "Ne pas remplir", // 不填写
        browse_bngh: "Aller remplir", // 去填写
        did_wwe: "Ajout réussi", // 添加成功
        calculate_mnrt: "Veuillez sélectionner un enregistrement de calcul", // 请选择计算记录
        ping_joi: "Confirmer la suppression de cet enregistrement ?", // 确定删除该记录？
        ping_jki: "Suppression réussie", // 删除成功
        ppn_oghs: "Modification réussie", // 修改成功
        empty_ccr: "Voulez-vous vraiment vider les éléments de calcul ? Vous pouvez restaurer les éléments supprimés dans Supprimés récemment.",
        supprime_cgd: "Voulez-vous supprimer définitivement ces calculs ? Cette action est irréversible.", // 确认彻底清除这些计算项吗？
        empty_ctl: "Confirmer la suppression de cet élément de calcul ? Vous pouvez le restaurer dans Supprimés récemment.", // 确认删除该计算项吗？

        // 新增或缺失的翻译（去重并备注原始中文）
        tiles_sanitary: "Carrelage & Sanitaire", // 原文: Tiles & Sanitary
        view: "Voir", // 原文: View
        real_case: "Cas Réels", // 原文: Real Case
        see_all: "Voir Tout", // 原文: See All
        appointment: "Rendez-vous", // 原文: Appointment
        distance: "km de toi", // 原文: km from you
        unable_to_locate: "Impossible de localiser", // 原文: Unable to locate
        brand: "Marque", // 原文: Brand
        collections: "Collections", // 原文: Collections
        login_successful: "Connexion réussie", // 原文: Login Successfully
        home: "Accueil", // 原文: Home
        display: "Affichage", // 原文: Display
        cases: "Cas", // 原文: Cases
        account: "Compte", // 原文: Account

        recommend_chrome: "Il est recommandé d’utiliser le navigateur Chrome pour accéder à la plateforme", // 原文: It is recommended to use Chrome browser to access
        not_chrome_use_chrome: "Vous utilisez actuellement un navigateur autre que Chrome, veuillez utiliser Google Chrome pour bénéficier d’une meilleure expérience.", // 原文: Currently non-Chrome...

        products: "Produits", // 原文: Products
        popular: "Populaire", // 原文: Popular
        popular_searches_hidden: "Les recherches populaires actuelles sont masquées", // 原文: Current Popular searches are hidden
        confirm_show_all_history: "Afficher tous les historiques ?", // 原文: Determine all historical records?
        search_for_all: "Rechercher toutes les informations", // 原文: Search for all
        bathroom: "Salle de bain", // 原文: Bathroom
        search_brand_info: "Rechercher des informations sur la marque", // 原文: Search for brand info
        search_space: "Rechercher par espace", // 原文: Search for space
        non_slip_tile: "Carrelage antidérapant", // 原文: Non-slip Tile
        please_enter_content: "Veuillez saisir un contenu", // 原文: Please enter content
        no_relevant_results: "Malheureusement, aucun résultat pertinent n’a été trouvé", // 原文: Unfortunately, there are no relevant results
        try_searching: "Essayez de rechercher à nouveau", // 原文: Try Searching
        more_products: "Plus de produits", // 原文: More Products
        more_cases: "Plus de cas", // 原文: More Cases

        search_for_store: "Rechercher un magasin", // 原文: Search for Store
        store_appointment: "Rendez-vous en magasin", // 原文: Store Appointment
        other_stores: "Autres magasins", // 原文: Other Stores
        loading_complete: "Chargement terminé", // 原文: Loading Complete
        loading: "Chargement...", // 原文: Loading...
        search_store: "Rechercher un magasin", // 原文: Search for Store
        nearby_stores: "Magasins à proximité", // 原文: Nearby Stores
        select_store: "Sélectionner un magasin", // 原文: Select Store
        cancel: "Annuler", // 原文: Cancel
        history: "Historique", // 原文: History
        artificial_service: "Service Artificiel", // 原文: Artificial Service
        online_service: "Service en Ligne", // 原文: Online Service

        product_not_exist: "Le produit n’existe pas", // 原文: 产品不存在
        product_offline: "Le produit a été mis en retrait", // 产品已下架

        amount: "Montant", // 原文: Amount
        appointment_info: "Information de rendez-vous", // 原文: Appointment Information
        service_evaluation: "Évaluation du service", // 原文: Service Evaluation
        remarks: "Remarques", // 原文: Remarks
        enter_additional_comments: "Entrez des commentaires additionnels", // 原文: Enter additional comments
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche",
        MON: "LUN",
        TUE: "MAR",
        WED: "MER",
        THU: "JEU",
        FRI: "VEN",
        SAT: "SAM",
        SUN: "DIM",
        to: "au", // 原文: to

        please_input: "Veuillez saisir", // 原文: Please Input
        please_select: "Veuillez sélectionner", // 原文: Please Select
        please_enter_your_needs: "Veuillez entrer vos besoins", // 原文: Please enter your needs
        appointment_time: "Heure de rendez-vous", // 原文: Appointment Time
        date: "Date",
        required_fields_not_selected: "Champs obligatoires non sélectionnés", // 原文: Required fields not selected.
        login_password_placeholder: "6+ caractères",  // 原文: 6+ characters
        time: "Heure",
        information: "Informations",
        name: "Nom",
        first_name: "Prénom",
        last_name: "Nom de famille",
        gender: "Genre",
        select_your_gender: "Sélectionnez votre genre", // 原文: Select your gender
        male: "Homme",
        female: "Femme",
        language: "Langue",
        select_language: "Sélectionner la langue",
        english: "Anglais",
        french: "Français",
        contact: "Contact",
        demand: "Demande",
        phone: "Téléphone",
        obtain: "Obtenir",
        submit: "Soumettre",
        confirm: "Confirmer",
        next: "Suivant",
        back: "Retour",

        sort_by: "Trier par",
        filter: "Filtrer",
        reset: "Réinitialiser",
        default: "Par défaut",
        newest: "Plus récent",
        trending: "Tendance",
        apply: "Appliquer",
        basic_colors: "Couleurs basiques",
        marble_stone: "Marbre & Pierre",
        download_app_3d: "Téléchargez l’application pour voir l’effet 3D",
        showroom_products: "Produits du showroom",
        matching_records: "Résultats correspondants",
        recognize_qr_code: "Scanner le code QR",

        product_details: "Détails du produit",
        renderings: "Rendus",
        related_cases_products_in_model_room: "Cas associés / Produits utilisés dans la salle modèle", // 原文: Related Cases样板间使用产品
        recommended_products: "Produits recommandés",
        display_3d: "Affichage 3D",
        collection: "Collection",
        basic_product_parameters: "Paramètres basiques du produit",
        functional_parameters: "Paramètres fonctionnels",
        close: "Fermer",
        share: "Partager",
        info_to: "Informations à",
        share_case_info_to: "Partager les informations du cas à",
        copy_link: "Copier le lien",
        space: "Espace",
        download_app_tip: "Téléchargez l'application pour voir l'effet 3D", // 原文: Download the app to view the 3D effect
        showroom_products: "Produits du showroom", // 原文: Showroom products

        log_in_with_account: "Se connecter avec un compte", // 原文: Log In with Account
        you_are_logging_into_account_for: "Vous vous connectez à un compte pour", // 原文: You are logging into an account for
        select_country_again: "Si vous ne vous trouvez pas dans ce pays, veuillez sélectionner à nouveau.", // 原文: If you are not in this country, please select again.
        registering_into_account_for: "You are creating an account for", // 原文: You are registering into an account for
        already_have_account: "Already have an account?", // 原文: Already have an account？
        phone_number_verification: "Vérification du numéro de téléphone",
        accept_sms_verification_code: "En acceptant le code de vérification par sms",
        confirm_number: "Confirm the number",
        enter_code_sent_to: "Enter the code sent to",
        send_new_code: "Envoyer un nouveau code",
        verification_code: "Code de vérification",
        reset_password: "Réinitialiser le mot de passe",
        other_login_method: "Autres méthodes de connexion", // 原文: Other login method
        retrieve_password: "Récupérer le mot de passe", // 原文: Retrieve password
        create_new_account: "Créer un nouveau compte", // 原文: Create New Account
        register: "S’inscrire", // 原文: Register
        registered_name: "Nom", // 原文: Name
        registered_first_name: "Prénom", // 原文: First Name
        registered_last_name: "Nom de famille", // 原文: Last Name
        registered_location: "Emplacement",
        registered_gender: "Genre",
        registered_gender_placeholder: "Homme ou Femme",
        registered_male: "Homme",
        registered_female: "Femme",
        registered_phone_placeholder: "Votre numéro de téléphone",
        registered_password_placeholder: "6+ caractères",
        registered_obtain: "Obtenir",
        registered_account_exists: "Le compte ... existe déjà",
        registered_merge_account: "Voulez-vous fusionner les informations de compte？",
        registered_cancel: "Annuler",
        registered_merge: "Fusionner",
        registered_email: "E-mail",
        registered_email_placeholder: "Votre adresse e-mail",
        login_other: "Autres méthodes de connexion",
        login_retrieve: "Récupérer le mot de passe",
        login_register: "S’inscrire",
        login_facebook: "Facebook",
        login_google: "Google",
        retrieve_phone_verification: "Vérification par téléphone",
        retrieve_sms_verification: "Vérification par SMS",
        retrieve_enter_code: "Entrez le code de vérification",
        retrieve_send_new_code: "Envoyer un nouveau code",
        retrieve_reset_password: "Réinitialiser le mot de passe",
        information_complete: "Veuillez compléter vos informations",
        information_not_complete: "Veuillez compléter vos informations",
        login_password_requirement: "Mot de passe doit contenir au moins 6 caractères, avec au moins une lettre majuscule, une lettre minuscule, et un chiffre.",
        your_phone_number: "Votre numéro de téléphone",
        password_requirement: "Password：6+ caractères",
        other_login: "Autres méthodes de connexion",
        facebook: "Facebook",
        google: "Google",

        shopping_list: "Liste de courses",
        wish_list: "Liste de souhaits",
        read_more: "En savoir plus", // 原文: Read More
        no_favorite_yet: "Pas encore de favoris", // 原文: No Favorite Yet
        no_case_yet: "Aucun cas", // 原文: No Case Yet
        store_experience_records: "Historique d’expérience en magasin",
        share: "Partager",
        give_a_gift: "Offrir un cadeau",
        my_cases: "Mes cas",
        go: "C’est parti !",
        no_cases: "Aucun cas",
        recently_viewed: "Consultés récemment",
        switching_countries_re_register: "Changer de pays nécessite de créer un nouveau compte, veuillez donc choisir avec précaution.",

        country_selection: "Sélection du pays",
        based_on_your_location: "En fonction de votre localisation",
        auto_selected_country: "un pays a été sélectionné automatiquement.",
        manual_select_country: "Si cette localisation est incorrecte, veuillez sélectionner manuellement votre pays.",
        switching_countries_requires_re_registering: "Changer de pays nécessite de créer un nouveau compte, veuillez donc choisir avec précaution.",

        select_all: "Tout sélectionner",
        remove: "Supprimer",
        finish: "Terminer",
        edit: "Modifier",
        saved: "Enregistré",
        favourite: "Favoris",
        confirm_clear_all_favorites: "Confirmez-vous la suppression de tous les favoris ?",
        all: "Tout",

        my_appointment: "Mes rendez-vous",
        store_record: "Fiche du magasin",
        purchase_history: "Historique d’achats",
        ongoing: "En cours",
        completed: "Terminé",
        considerate_service: "Service attentionné",
        attentive: "Attentif",
        patience: "Patient",
        communicate_smoothly: "Bonne communication",
        high_professional: "Très professionnel",
        bad_attitude: "Mauvaise attitude",
        service_appointment_details: "Détails du rendez-vous",
        show_appointment_code: "Afficher le code de rendez-vous",
        my_appointment_history: "Mon historique de rendez-vous",
        back_to_home: "Retour à l’accueil",
        appointment_code_expired: "Code de rendez-vous expiré",
        no_record: "Aucun enregistrement",
        browse_records: "Parcourir les enregistrements",
        details: "Détails",
        product_list: "Liste des produits",
        no_browsing_history: "Aucun historique de navigation",
        purchase_history_detail: "Détail de l’historique d’achats",
        arrived: "Arrivé",
        times: "fois",
        payment_voucher: "Reçu de paiement",
        purchase_list: "Liste des achats",
        brick_units_are_boxes: "Les unités de carreaux sont des boîtes",
        store_service_appointment: "Rendez-vous de service en magasin",
        thanks_for_appointment: "Merci pour votre rendez-vous ! Nous avons hâte de vous accueillir !",
        contact_shopping_guide: "Contacter le conseiller en magasin",
        appointment_code: "Code de rendez-vous",
        show_to_shop_guider: "À montrer au gérant",
        go_to_shopping_list: "Aller à la liste de courses",
        service_appointment: "Rendez-vous de service",

        location_failed: "Échec de la localisation",
        positioning: "Localisation en cours...",
        re_locate: "Relancer la localisation",
        current_location: "Localisation actuelle",
        search_for_city: "Rechercher une ville",

        case_details: "Détails du cas",
        products_applied: "Produits utilisés",
        uploader: "Téléversé par",
        related_cases: "Cas associés",
        case: "Cas",
        page_situation: "Situation de la page",   //原文中文：页面情况
        situation1: "1、Search box temporarily cannot be clicked\n2、Case type interface network error\n3、Select city module waiting for location api\n4、Floating button cannot be clicked\n5、Case list data is missing part of the keyword\n6、Case list interface parameter sort is missing another data", // 原文中文：1、搜索框暂时不能点击\n2、案例分类接口报网络错误\n3、选择城市模块等待定位api\n4、悬浮按钮不能点击\n5、案例列表数据缺失部分关键字\n6、案例列表接口入参sort缺少另外的数据
        situation2: "1、Get details interface not working\n2、Top bar temporarily not debugged", // 原文中文：1、获取详情接口不通\n2、顶部栏暂时未调试
        situation3: "1、Recent shop location problem\n2、Interface returns video address cannot play\n3、Detail data is missing \n4、Customer service icon is missing\n", // 原文中文：1、最近商铺定位问题\n2、接口返回视频地址无法播放\n3、详情数据缺失 \n4、客服图标缺失\n

        calculator: "Calculatrice",
        meter: "mètre (m)",
        feet: "pieds (ft)",
        system_calc_method: "Méthode de calcul du système : 1 m² = 10,7639104167 sqft",
        add_products: "Ajouter des produits",
        add_from: "Ajouter depuis les ",
        t_collections: "collections",
        t_matching_records: "records de correspondance",
        t_favorites: "favoris",
        t_recently_viewed: "vues récentes",
        select_space: "Sélectionner l'espace",
        wall: "Mur",
        floor: "Sol",
        continuous_laying: "Pose continue",
        area: "Surface",
        door: "Porte",
        window: "Fenêtre",
        pcs: "PCS",
        m2: "m²",
        sqft: "sqft",
        change_products: "Changer de produit",
        subtotal: "Sous-total",
        box: "Carton",
        grand_total: "Total général",
        add_to_shopping_list: "Ajouter à la liste d’achats",
        add_from_collections: "Ajouter depuis les collections",
        add_from_favorites: "Ajouter depuis les favoris",

        select_unit: "Sélectionner l’unité",
        please_select_space_first: "Veuillez d’abord sélectionner un espace",
        copied: "Copié",
        deleted: "Supprimé",
        clearing: "Nettoyage",
        saved_to_customer_view_pending_purchase_list: "Enregistré pour le client vous pouvez voir la liste d’achats en attente",
        cannot_add_zero_box_products: "Les produits avec zéro boîte ne peuvent pas être ajoutés à la liste d’achats",

        id_number: "Numéro d’identification",
        client: "Client",
        edited: "Modifié",
        discount: "Remise",
        last_price: "Dernier prix",
        favorite_successfully: "Ajouté aux favoris avec succès",
        success: "Succès",
        unknown_current_region: "Région actuelle inconnue",
        login_before_scan: "Veuillez vous connecter avant de scanner pour voir", // 原文中文: 请先登录后再扫码查看
        invalid_qr_code: "Code QR invalide", // 原文中文: 无效的二维码
        error_need_camera_permission: "Erreur : Vous devez autoriser l’accès à la caméra", // 原文中文: ERROR: 您需要授予相机访问权限
        error_no_camera_detected: "Erreur : Aucun appareil photo détecté", // 原文中文: ERROR: 这个设备上没有摄像头
        error_secure_context_required: "Erreur : Contexte sécurisé requis (HTTPS, localhost)", // 原文中文: ERROR: 所需的安全上下文(HTTPS、本地主机)
        error_camera_in_use: "Erreur : La caméra est occupée", // 原文中文: ERROR: 相机被占用
        error_camera_install_incorrect: "Erreur : Installation de la caméra incorrecte", // 原文中文: ERROR: 安装摄像头不合适
        error_browser_not_support_stream_api: "Erreur : Ce navigateur ne supporte pas l’API vidéo", // 原文中文: ERROR: 此浏览器不支持流API
        recognition_error: "Erreur de reconnaissance", // 原文中文: 识别错误
        information_not_complete: "Informations incomplètes", // 原文: Information is not complete
        thank_you_feedback: "Merci pour votre retour",
        feedback_submission_failed: "Échec de l’envoi du retour",
        applied: "Appliqué",
        fail: "Échec",
        choose_picture: "Choisir une image", // 原文中文
        error_get_details_failed: "Échec de récupération des détails", // 原文中文: 获取详情失败
        save_success: "Enregistrement réussi", // 原文中文: 保存成功
        third_party_account_binding: "Lier un compte tiers", // 原文中文: 绑定第三方账号
        bind: "Lier", // 原文中文: 绑定
        phone_info: "Numéro de téléphone", // 原文中文: 手机号
        association_failed: "Association échouée", // 原文中文: 关联失败
        zoom_in: "Agrandir", // 原文中文: 放大
        zoom_out: "Réduire", // 原文中文: 缩小
        zoom: "Zoom", // 原文中文: 缩放
        
        // 新增缺失的翻译项
        thank_you_for_your_feedback: "Merci pour votre retour", // 原文: Thank you for your feedback
        feedback_submission_failed: "Échec de l’envoi du retour", // 原文: Failed to submit feedback
        recently_deleted: "Supprimés récemment", // 原文: Recently Deleted
        no_space_selected: "Aucun espace sélectionné", // 原文: No space selected
        continuous_laying_quote: "Pose continue", // 原文: "Continuous laying"
        length: "Longueur", // 原文: Length
        width: "Largeur", // 原文: Width
        in_total: "En total", // 原文: In Total
        total: "Total", // 原文: Total
        not_logged_in: "Non connecté", // 原文: Not Logged In
        no_data_yet: "Aucune donnée pour le moment", // 原文: No data yet
        restore: "Restaurer", // 原文: Restore
        clear: "Effacer", // 原文: Clear
        search_product_name: "Rechercher un nom de produit", // 原文: Search for product name
        set_up: "Paramètres", // 原文: Set Up
        log_out: "Se déconnecter", // 原文: Log Out
        personal_info: "Informations personnelles", // 原文: Personal Info
        account_security: "Sécurité du compte", // 原文: Account Security
        change_password: "Changer le mot de passe", // 原文: Change Password
        enter_first_name: "Entrez votre prénom", // 原文: Enter your first name
        enter_last_name: "Entrez votre nom", // 原文: Enter your last name
        location: "Localisation", // 原文: Location
        select_country_province_city: "Sélectionner Pays / Province / Ville", // 原文: 'Select Country / Province / City'
        select_gender: "Sélectionnez votre genre", // 原文: Select your gender
        user_info_changed_save: "Les informations utilisateur ont été modifiées, souhaitez-vous enregistrer ?", // 原文: 用户信息有变动，是否保存
        switching_countries_requires_re_registering2: "Changer de pays nécessite de recréer votre compte", // 原文: Switching countries requires re-registering your account
        sort: "Trier", // 原文: Sort
        browsing_type: "Type de navigation", // 原文: Browsing Type
        content: "Contenu", // 原文: Content
        offline: "Hors ligne", // 原文: Offline
        time_new_old: "Temps (du plus récent au plus ancien)", // 原文: Time (new-old)
        time_old_new: "Temps (du plus ancien au plus récent)", // 原文: Time (old-new)
        views_most_least: "Vues (de la plus élevée à la plus basse)", // 原文: Views (most-least)
        views_least_most: "Vues (de la plus basse à la plus élevée)", // 原文: Views (least-most)
        online_browsing: "Navigation en ligne", // 原文: Online Browsing
        return: "Retour", // 原文: 返回
        unlocked: "Débloqué", // 原文: Unlocked
        not_unlocked: "Non débloqué", // 原文: Not unlocked
        rating: "Note", // 原文: Rating
        course_introduce: "Présentation du cours", // 原文: Course Introduce
        tap_star_to_score: "Appuyez sur une étoile pour noter", // 原文: Tap Star To Score
        what_think_of_course: "Que pensez-vous du cours ?", // 原文: What do you think of the course?
        take_an_exam: "Passer un examen", // 原文: Take An Exam
        points: "Points", // 原文: Points
        today: "Aujourd’hui", // 原文: Today
        before: "Avant", // 原文: Before
        min: "min", // 原文: Min
        learn: "Apprendre", // 原文: Learn
        learned: "Texte appris", // 原文: 已学
        template: "<modèle>", // 原文: <template>
        list_of_the: "Liste des", // 原文: List of the
        year: "Année", // 原文: Year
        month: "Mois", // 原文: Month
        period_of_statistics: "Période de statistiques", // 原文: Period of statistics
        annual: "Annuel", // 原文: Annual
        monthly: "Mensuel", // 原文: Monthly
        no_more: "Il n’y a plus rien", // 原文: 没有更多了
        by_date: "par date", // 原文: by date
        budget: "Budget", // 原文: Budget
        overall_points_ranking: "Classement total des points", // 原文: Overall points ranking
        learning_points_ranking: "Classement des points d’apprentissage", // 原文: Learning points ranking
        lecturers_points_ranking: "Classement des points des formateurs", // 原文: Lecturers points ranking
        course_scoring_ranking: "Classement des notes des cours", // 原文: Course scoring ranking
        january: "Janvier", // 原文: January
        february: "Février", // 原文: February
        march: "Mars", // 原文: March
        april: "Avril", // 原文: April
        may: "Mai", // 原文: May
        june: "Juin", // 原文: June
        july: "Juillet", // 原文: July
        august: "Aout", // 原文: August
        september: "Septembre", // 原文: September
        october: "Octobre", // 原文: October
        november: "Novembre", // 原文: November
        december: "Decembre", // 原文: December
        category: "Catégorie", // 原文: Category
        all_course: "Tous les cours", // 原文: All Course
        determine_all_historical_records: "Afficher tous les historiques", // 原文: Determine all historical records
        search_for_all: "Rechercher Tout", // 原文: Search for all
        lecturer: "Formateur", // 原文: Lecturer
        application: "Application", // 原文: Application
        application_process: "1.Soumettre les données – 2. En attente de validation – 3. Contacter une personne si la validation est réussie", // 原文: 1.Submit data - 2.Wait for review - 3.Contact someone if the review is successful
    },
    // 商学院翻译
    business_school: {
        business_school: "École de Commerce",
        become_lecturer: "Devenir Formateur",
        category: "Catégorie",
        all_course: "Tous les cours",
        my_learning: "Mes apprentissages",
        ranking: "Classement",
        learning_history: "Historique d’apprentissage",
        all: "Tout",
        favorite: "Favoris",
        
        // 新增商学院相关翻译项
        unfortunately_there_are_no: 'Malheureusement, il n’y a pas de',
        relevant_results: 'Résultats pertinents',
        selected_all: "Sélectionné tout", // 原文: Selected all
        removed: "Supprimé", // 原文: Removed
        please_select_at_least_one_course_to_remove: "Veuillez sélectionner au moins un cours à supprimer", // 原文: Please select at least one course to remove
        removed_successfully: "Supprimé avec succès", // 原文: Removed successfully
        course: "Cours", // 原文: Course
        take_exam: "Passer un examen", // 原文: Take An Exam
        course_intro: "Présentation du cours", // 原文: Course Introduce
        tap_star_to_score: "Appuyez sur une étoile pour noter", // 原文: Tap Star To Score
        what_do_you_think_of_course: "Que pensez-vous du cours ?", // 原文: What do you think of the course?
        thank_you_for_feedback: "Merci pour votre retour", // 原文: Thank you for your feedback
        failed_to_submit_feedback: "Échec de l’envoi du retour", // 原文: Failed to submit feedback
        points: "Points", // 原文: Points
        today: "Aujourd’hui", // 原文: Today
        before: "Avant", // 原文: Before
        min: "min", // 原文: Min
        learn: "Apprendre", // 原文: Learn
        learned: "Texte appris", // 原文: 已学
        list_of_the: "Liste des", // 原文: List of the
        year: "Année", // 原文: Year
        month: "Mois", // 原文: Month
        period_of_statistics: "Période de statistiques", // 原文: Period of statistics
        annual: "Annuel", // 原文: Annual
        monthly: "Mensuel", // 原文: Monthly
        no_more: "Il n’y a plus rien", // 原文: 没有更多了
        by_date: "par date", // 原文: by date
        budget: "Budget", // 原文: Budget
        overall_points_ranking: "Classement total des points", // 原文: Overall points ranking
        learning_points_ranking: "Classement des points d’apprentissage", // 原文: Learning points ranking
        lecturers_points_ranking: "Classement des points des formateurs", // 原文: Lecturers points ranking
        course_scoring_ranking: "Classement des notes des cours", // 原文: Course scoring ranking
        january: "Janvier", // 原文: January
        february: "Février", // 原文: February
        march: "Mars", // 原文: March
        april: "Avril", // 原文: April
        may: "Mai", // 原文: May
        june: "Juin", // 原文: June
        july: "Juillet", // 原文: July
        august: "Aout", // 原文: August
        september: "Septembre", // 原文: September
        october: "Octobre", // 原文: October
        november: "Novembre", // 原文: November
        december: "Decembre", // 原文: December
        lecturer: "Formateur", // 原文: Lecturer
        application: "Application", // 原文: Application
        application_process: "1.Soumettre les données – 2. En attente de validation – 3. Contacter une personne si la validation est réussie", // 原文: 1.Submit data - 2.Wait for review - 3.Contact someone if the review is successful
        applied: "Appliqué", // 原文: Applied
        fail: "Échec", // 原文: Fail
    }
}

export default fr;


// WEBPACK FOOTER //
// ./src/VueI18n/fr.js